export type EmbeddedAssigneeMeta = {
  email?: string;
  first_name?: string;
  last_name?: string;
};

export function collectAssigneeIdsFromTask(item: Record<string, unknown>): string[] {
  const ids: string[] = [];
  const raw = item.assigned_users;
  if (Array.isArray(raw)) {
    for (const u of raw) {
      if (typeof u === "string" && u.trim()) {
        ids.push(u);
      } else if (
        u &&
        typeof u === "object" &&
        "id" in u &&
        typeof (u as { id: string }).id === "string"
      ) {
        ids.push((u as { id: string }).id);
      }
    }
  }
  const assignedTo = item.assigned_to;
  if (typeof assignedTo === "string" && assignedTo.trim()) ids.push(assignedTo);
  const au = item.assigned_user as { id?: string } | undefined;
  if (au?.id) ids.push(au.id);
  return [...new Set(ids)];
}

export function collectEmbeddedAssigneeMeta(
  item: Record<string, unknown>
): Map<string, EmbeddedAssigneeMeta> {
  const m = new Map<string, EmbeddedAssigneeMeta>();
  const raw = item.assigned_users;
  if (!Array.isArray(raw)) return m;
  for (const u of raw) {
    if (!u || typeof u !== "object" || !("id" in u)) continue;
    const o = u as {
      id: string;
      email?: string;
      first_name?: string;
      last_name?: string;
    };
    if (typeof o.id !== "string" || !o.id.trim()) continue;
    const prev = m.get(o.id) ?? {};
    m.set(o.id, {
      ...prev,
      email: o.email?.trim() || prev.email,
      first_name: o.first_name?.trim() || prev.first_name,
      last_name: o.last_name?.trim() || prev.last_name,
    });
  }
  return m;
}
